export default __webpack_public_path__ + "static/media/Breeches of the Ubah Kan.683ffe97.jpg";